import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from '../common';
import { Submenu } from './Submenu';

const Text = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors[props.color]};
  padding-left: 10px;
  text-decoration: none;
  white-space: nowrap;
`;

// Item principal da sidebar (Dashboard, Pedidos, Cupons, etc.)
const StyledNavLink = styled(NavLink)`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 44px;
  padding: 0 16px;
  font-weight: 700;
  text-decoration: none;
  opacity: ${(props) => (props.disabled ? '0.4' : '1')};
  border-radius: 999px;
  margin: 4px 8px;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover,
  &.selected {
    background-color: ${(props) => props.theme.colors.primary};
    text-decoration: none;

    ${Text} {
      color: white;
    }

    svg path:not([fill='none']) {
      fill: white !important;
    }

    svg path:not([stroke='none']) {
      stroke: white !important;
    }
  }

  &[data-link-id='now']:hover,
  &[data-link-id='now'].selected {
    background-color: ${(props) => props.theme.colors.success};
  }
`;

// Item que abre/fecha submenu (ex.: Cupons, Minha Loja)
const StyledNavLinkSubmenu = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 44px;
  padding: 0 16px;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  opacity: ${(props) => (props.disabled ? '0.4' : '1')};
  border-radius: 999px;
  margin: 4px 8px;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover,
  &.selected {
    background-color: ${(props) => props.theme.colors.primary};
    text-decoration: none;

    ${Text} {
      color: white;
    }

    svg path:not([fill='none']) {
      fill: white !important;
    }

    svg path:not([stroke='none']) {
      stroke: white !important;
    }
  }

  &[data-link-id='now']:hover,
  &[data-link-id='now'].selected {
    background-color: ${(props) => props.theme.colors.success};
  }
`;

const SubmenuArrow = styled.span`
  margin-left: auto;
  margin-right: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  transform: rotate(${(props) => (props.$isOpen ? '-90deg' : '90deg')});
`;

const SubmenuWrapper = styled.div`
  overflow: hidden;
  max-height: ${(props) => (props.$isOpen ? '400px' : '0')};
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  transition: max-height 0.3s ease, opacity 0.25s ease;
  padding-left: 4px;
`;

export const NavItem = ({
  id,
  icon,
  color,
  name,
  link,
  submenu,
  subnav,
  showSubnav,
  disabled,
}) => (
  <>
    {submenu && submenu.length > 0 ? (
      <StyledNavLinkSubmenu
        disabled={disabled}
        onClick={() => !disabled && showSubnav(!subnav ? `submenu#${name}` : null)}
      >
        <Icon width="16px" height="16px" name={icon} stroke={color} fill={color} />
        <Text color={color}>{name}</Text>
        <SubmenuArrow $isOpen={subnav === `submenu#${name}`}>
          <Icon width="12px" height="12px" name="arrowRight" stroke={color} fill={color} />
        </SubmenuArrow>
      </StyledNavLinkSubmenu>
    ) : (
      <StyledNavLink
        disabled={disabled}
        data-link-id={id}
        to={link}
        activeClassName="selected"
      >
        <Icon width="16px" height="16px" name={icon} stroke={color} fill={color} />
        <Text color={color}>{name}</Text>
      </StyledNavLink>
    )}

    {submenu && submenu.length > 0 && (
      <SubmenuWrapper $isOpen={subnav === `submenu#${name}`}>
        {submenu.map((sub) => (
          <Submenu
            key={`submenu#${sub.name}`}
            id={sub.id}
            color={sub.color}
            name={sub.name}
            link={sub.link}
          />
        ))}
      </SubmenuWrapper>
    )}
  </>
);
